import PageTitle from 'components/base/title/PageTitle';
import AppModal from 'components/common/modal/AppModal';
import PlainModal from 'components/common/modal/PlainModal';
import NoticeModal from 'components/dashboard/NoticeModal';
import { AppContext } from 'contexts/AppContext';
import { dashboardGridKey, pageUrl } from 'lib/mapper';
import storage, { deleteCookie, getCookie, keys, setCookie } from 'lib/storage';
import { ILoginUser } from 'lib/types/sharedTypes';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Layout } from 'react-grid-layout';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DashboardActions, UserActions, UtilActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { isClinicUserSelector } from 'store/modules/user';
import styled from 'styled-components';
import BannerContainer from './BannerContainer';
import MillingStatusContainer from './MillingStatusContainer';
import PatientContainer from './PatientContainer';
import ProjectStatusContainer from './ProjectStatusContainer';
import SalesContainer from './SalesContainer';
import ScheduleContainer from './ScheduleContainer';
import StoreContainer from './StoreContainer';
import { IMainNotification } from 'lib/types/utilTypes';

export default function DashboardContainer() {
  const {
    language,
    user,
    noNoticeState,
    isClinicUser,
    layoutData: { layout: layoutDataValue },
    adminNotification: { data: notificationData },
    adminNotificationSuccess,
  }: {
    language: string;
    user: ILoginUser;
    noNoticeState: boolean;
    isClinicUser: boolean;
    layoutData: { layout: string };
    adminNotification: { data: IMainNotification };
    adminNotificationSuccess: boolean;
  } = useShallowAppSelector(state => ({
    language: state.base.language,

    user: state.user.user || {},
    noNoticeState: state.user.noNoticeState,
    isClinicUser: isClinicUserSelector(state),
    layoutData: state.dashboard.layout.data || {},
    adminNotification: state.util.adminNotification.data || {},
    adminNotificationSuccess: state.util.adminNotification.success,
  }));
  const history = useHistory();
  const [isNotiModal, setIsNotiModal] = useState<boolean>(false);
  const [layoutState, setLayoutState] = useState<Layout[] | null>(null);
  const { uiDraggable } = useContext(AppContext);
  const { t } = useTranslation();
  const isNoNotice = user?.isNoNotice;

  const defaultLayout = [
    { i: dashboardGridKey.schedule, x: 0, y: 0, w: 6, h: 9 },
    // { i: dashboardGridKey.notifications, x: 6, y: 0, w: 6, h: 10.9 },
    { i: dashboardGridKey.sales, x: 6, y: 0, w: 6, h: 9 },
    { i: dashboardGridKey.patient, x: 6, y: 0, w: 6, h: 9 },
    { i: dashboardGridKey.projectStatus, x: 0, y: 1, w: 9, h: 9 },
    // { i: dashboardGridKey.salesStore, x: 0, y: 1, w: 3, h: 10.9 },
    { i: dashboardGridKey.store, x: 9, y: 1, w: 3, h: 9 },
    { i: dashboardGridKey.banner, x: 9, y: 1, w: 3, h: 9 },
    // { i: dashboardGridKey.banner, x: 0, y: 3, w: 12, h: 8 },
    // { i: dashboardGridKey.updatedProject, x: 0, y: 4, w: 6, h: 10.9 },
    // { i: dashboardGridKey.milling, x: 6, y: 4, w: 6, h: 10.9 },
    // { i: dashboardGridKey.lectures, x: 0, y: 5, w: 12, h: 7 },
    // { i: dashboardGridKey.partners, x: 0, y: 6, w: 12, h: 10.9 },
  ];
  const layout = useMemo(() => {
    const findKeyPartner = layoutDataValue?.indexOf(dashboardGridKey.partners);
    if (!!findKeyPartner) {
      const returnLayoutDataValue = layoutDataValue?.replace(
        dashboardGridKey.partners,
        dashboardGridKey.milling,
      );
      return returnLayoutDataValue ? JSON.parse(returnLayoutDataValue) : defaultLayout;
    } else {
      return layoutDataValue ? JSON.parse(layoutDataValue) : defaultLayout;
    }
  }, [layoutDataValue]);

  useEffect(() => {
    DashboardActions.fetch_layout_request();
  }, []);

  useEffect(() => {
    // 초기값 null, 토글 시 true, false(저장)
    if (uiDraggable === false) {
      const layoutData = JSON.stringify(layoutState);
      DashboardActions.edit_layout_request({ layout: JSON.stringify(layoutState) });
    }
  }, [uiDraggable]);

  useEffect(() => {
    if (!adminNotificationSuccess) return;
    const cookieNoticeModify = getCookie(keys.notice_modify_date);

    if (!notificationData) {
      // notification 데이터가 없는 알림데이터 없음 모달x
      console.log('HDS] notificationData 없음, storage & cookie 삭제, 팝업 X');
      setIsNotiModal(false);
      storage.remove(keys.user_no_notice);
      deleteCookie(keys.notice_modify_date);
    } else {
      console.log(
        'AdminNotice] adminNotification modifyDate _____ ',
        new Date(notificationData.modifyDate * 1000),
      );
      console.log(
        'AdminNotice] adminNotification expires _____ ',
        new Date(notificationData.expireDate * 1000),
      );
      if (!!cookieNoticeModify && cookieNoticeModify === String(notificationData.modifyDate)) {
        console.log('AdminNotice] cookieNoticeModify 존재하고, modifyDate가 [[ 일치 ]]');
        console.log('AdminNotice] ----> 다시보지않기 및 noNoticeState 체크');
        if (
          !noNoticeState && // noNoticeState가 true이고,
          !isNoNotice // isNoNotice true이고,
        ) {
          setIsNotiModal(true);
          console.log('AdminNotice] noNoticeState false이고, 다시보지 않기 X');
        } else {
          setIsNotiModal(false);
          console.log('AdminNotice] noNoticeState true 이거나, 다시보지 않기 O');
        }
      } else {
        console.log('AdminNotice] cookieNoticeModify 없거나, modifyDate가 [[ 불일치 ]]');
        console.log('AdminNotice] ----> storage 초기화, 쿠키 생성/갱신, 팝업 O');
        storage.remove(keys.user_no_notice);
        setCookie(keys.notice_modify_date, notificationData.modifyDate, {
          expires: new Date(notificationData.expireDate * 1000),
        });
        setIsNotiModal(true);
      }
    }
  }, [isNoNotice, noNoticeState, notificationData, adminNotificationSuccess]);

  const handleCloseModal = () => {
    setIsNotiModal(false);
    UserActions.set_no_notice(true);
  };

  const handleClickNoRepeat = () => {
    const noRepeatUser = storage.get(keys.user_no_notice) || [];
    const addNoRepeatUser = new Set([...noRepeatUser, user.email]);
    storage.set(keys.user_no_notice, [...addNoRepeatUser]);
    setTimeout(() => {
      UserActions.fetch_profile_request();
    }, 100);
    setIsNotiModal(false);
  };
  const handleClickNextAction = (type: 'SOFTWARE' | 'GENERAL') => {
    setIsNotiModal(false);
    UserActions.set_no_notice(true);
    if (type === 'SOFTWARE') {
      history.push(pageUrl.store.index);
    }
  };

  useEffect(() => {
    UtilActions.fetch_admin_notification_request({ language: language.toUpperCase() });
  }, [language]);

  return (
    <StyledDashboardContainer data-component-name="DashboardContainer">
      {useMemo(() => {
        return (
          <PlainModal isOpen={isNotiModal} onClose={handleCloseModal} width={570}>
            <AppModal
              title={t('NOTICE_MODAL_TITLE')}
              content={
                <NoticeModal
                  language={language}
                  notice={notificationData}
                  onClickNoRepeat={handleClickNoRepeat}
                  onClickNextAction={handleClickNextAction}
                />
              }
              contentCardStyle={{
                padding: '0 0 28px',
                backgroundColor: 'transparent',
              }}
              isCloseIcon={true}
              onCancel={handleCloseModal}
              hideButton={true}
            />
          </PlainModal>
        );
      }, [isNotiModal, notificationData])}
      <PageTitle title={t(`NAV_MENU_HOME`)} className="sr-only" />
      <div className="dashboard__container">
        <div className="dashboard__container_row">
          <ScheduleContainer className="dashboard__schedule" />
          {isClinicUser ? (
            <PatientContainer className="dashboard__patient" />
          ) : (
            <SalesContainer className="dashboard__sales" />
          )}
        </div>
        <div className="dashboard__container_row">
          <ProjectStatusContainer
            className="dashboard__project_status_container"
            isNormalLevelUser={false}
          />
          <MillingStatusContainer />
          {/* {isClinicUser ? (
            <BannerContainer className="dashboard__banner" />
          ) : (
            <StoreContainer className="dashboard__store" />
          )} */}
          <StoreContainer className="dashboard__store" />
        </div>
      </div>
    </StyledDashboardContainer>
  );
}

const StyledDashboardContainer = styled.section`
  .border-radius-default {
    border-radius: 15px;
  }

  .dashboard__container {
    position: relative;
    .dashboard__container_row {
      display: flex;
      column-gap: 20px;
      height: 450px;
    }

    .dashboard__card_title_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      width: 100%;
    }
    .dashboard__card_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      font-weight: 500;
      color: #222;
      line-height: 34px;
      .dashboard__card_title_icon {
        margin-right: 15px;
      }
    }
  }

  .dashboard__slider_box {
    width: 100%;
  }

  .dashboard__division {
    margin: 50px 0;
    width: 100%;
    height: 3px;
    background-color: #e6e6e6;
    border: none;
  }
`;
